import { IAuthState, IAuthUser } from "@command-center-app/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IAuthState = {
  token: "",
  user: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginRequest(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action: PayloadAction<{ data: IAuthUser }>) {
      state.loading = false;
      state.user = action.payload.data;
    },
    loginFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setUser(state, action: PayloadAction<IAuthUser>) {
      state.user = action.payload;
    },
  },
});

export const { loginRequest, loginSuccess, loginFailed, setToken, setUser } =
  authSlice.actions;
export default authSlice.reducer;
